import Hero from "../components/Hero";
import ProductShowcase from "../components/ProductShowcase";
import ProductGallery from "../components/ProductGallery";  

export default function Home() {

  return (
    <>
      <Hero />
      <ProductShowcase />
      <ProductGallery />
    </>
  );
}
